// extracted by mini-css-extract-plugin
export default {"week":"weekHeads_week__a4VCO","headsOfWeek":"weekHeads_headsOfWeek__QJxKr","yearView":"weekHeads_yearView__Tz-DW"};